import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { PrimeNG } from "primeng/config";
import { MessageService as PrimeMessageService } from 'primeng/api';

import { MessageService } from '@app/core/message.service';
import { SharedDataService } from '@app/services/net-remit/shared-data.service';
import { PaymentsService } from '@app/services/net-remit/payments.service';
import { CustomerService } from '@app/services/net-remit/customer.service';
import { SharedService } from '@app/services/net-remit/shared-functions.service';
import { MacroGroupsService } from '@app/services/net-remit/macro-groups.service';
import { RemoteAccountService } from '@app/services/net-remit/remote-account.service';

import { ErrorView } from '@app/shared/models/ErrorView';
import { CustomerEntityView } from '@app/shared/models/CustomerEntityView';
import { ComboKeysView } from '@app/shared/models/ComboKeysView';
import { MemoContentOriginView } from '@app/shared/views/MemoContentOriginView';
import { AgentsMacroGroupView } from '@app/shared/views/AgentsMacroGroupView';
import { RemoteAccountView } from '@app/shared/views/RemoteAccountView';
import { MemoPaymentView } from '@app/shared/views/MemoPaymentView';
import { FileTypeView } from '@app/shared/views/FileTypeView';
import { FileSequenceDataView } from '@app/shared/views/FileSequenceDataView';
import { AirlineCountriesView } from '@app/shared/models/AirlineCountriesView';
import { CountryView } from '@app/shared/models/ipm/view/CountryView';

import { finalize, takeWhile } from 'rxjs/operators';
import { fadeIn } from 'assets/animations/animations';

import { default as constantsFile } from '@app/shared/constants.json';
import { MESSAGE_TYPE } from '@app/shared/models/Message';
import { forkJoin } from 'rxjs';


@Component({
    selector: 'app-new-payment',
    templateUrl: './new-payment.component.html',
    styleUrls: ['./new-payment.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class NewPaymentComponent implements OnInit, OnDestroy
{
  enableRemotes: boolean;
  uploadRemoteList: Array<RemoteAccountView>;
  remoteResponseList: Array<RemoteAccountView>;

  alive: boolean = true;
  attemptToSave: boolean;
  constants: any = constantsFile.constants;
  isLoading: boolean = true;
  isLoadingCustomer: boolean;
  isLoadingMacroGroups: boolean;
  isLoadingOriginContent: boolean;
  isLoadingFileSequence: boolean;
  isLoadingRemotes: boolean;
  isPeriodicPayment: boolean;
  isSinglePayment: boolean = null;
  isPeriodRangePayment: boolean = null;
  paymentSavedOk: boolean;

  fileInput: File = null;

  minFileSequence: number = 0;
  maxFileSequence: number = 999;

  memoContentOriginSelected: string;
  paymentDefaultTranslated: string;

  allOriginContent: Array<MemoContentOriginView>;
  originContent: Array<MemoContentOriginView>;

  //Forms
  paymentFormInvalid: boolean = true;
  singleFormInvalid: boolean = true;
  periodicFormInvalid: boolean = true;
  periodRangeFormInvalid: boolean = true;

  // Valores de constantes
  arc: string = this.constants.memoContentOrigin.arc;
  bsp: string = this.constants.memoContentOrigin.bsp;
  acm: string = this.constants.ACDMdocTypes.ACM;
  adm: string = this.constants.ACDMdocTypes.ADM;
  acdm: string = this.constants.ACDMdocTypes.ACDM;
  manualCaptureBsp: string = this.constants.memoContentOrigin.manualCaptureBsp;
  manualCaptureArc: string = this.constants.memoContentOrigin.manualCaptureArc;

  // Listas de constantes
  singlePaymentMemoContentOrigin: Array<string> = new Array<string>(this.manualCaptureBsp, this.manualCaptureArc);
  periodicPaymentMemoContentOrigin: Array<string> = new Array<string>(this.arc, this.bsp);
  bspMemoContentOriginList: Array<string> = new Array<string>(this.manualCaptureBsp, this.bsp);

  defaultMaxRelated: number;
  diffValueMaxRelated: number;
  diffCountry: string;
  docTypesList: FileTypeView[];
  docTypesListSingle: FileTypeView[];
  frequencyList: ComboKeysView[];
  pattern: any = this.constants.pattern;
  paymentTypesList: ComboKeysView[];
  singleFrequency: string = this.constants.memoFrequency.single;
  periodicFrequency: string = this.constants.memoFrequency.periodic;
  periodRangeFrequency: string = this.constants.memoFrequency.periodRange;
  periodicFileName: string = this.constants.periodicPayment.fileName;
  typeError: string = this.constants.typeMessage.error;
  typeInfo: string = this.constants.typeMessage.info;

  // Variable de control
  maxRelatedAllowed: number;
  isMaxRelatedHigherMax: boolean;
  isMaxRelatedZero: boolean;

  // Variables
  airlineList: Array<AirlineCountriesView> = new Array<AirlineCountriesView>();
  agentsMacroGroupsList: Array<AgentsMacroGroupView> = new Array<AgentsMacroGroupView>();
  customerList: Array<CustomerEntityView> = new Array<CustomerEntityView>();
  countryList: Array<CountryView> = new Array<CountryView>();
  frequency: string;
  isErrorConnection: boolean;
  newPaymentView: MemoPaymentView;
  cancelClicked: boolean;

  // Errores
  errorRabbit: boolean;
  errorFileSequence: boolean;
  generalError: string;
  messagesError: Array<any>;

  // Errores api
  docTypeError: ErrorView;
  NameError: ErrorView;
  airlineError: ErrorView;
  bspError: ErrorView;
  maxRelatedError: ErrorView;
  fileSequenceError: ErrorView;
  paymentError: ErrorView;
  paymentTypeError: ErrorView;
  vatError: ErrorView;
  fromDocumentError: ErrorView;
  toDocumentError: ErrorView;
  contactNameError: ErrorView;
  contactPhoneError: ErrorView;
  contactEmailError: ErrorView;
  RMICError: ErrorView;
  reasonForMemoError: ErrorView;
  memoContentError: ErrorView;
  endTaskDateError: ErrorView;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    private customerService: CustomerService,
    private macroGroupsService: MacroGroupsService,
    private messageService: MessageService,
    private paymentService: PaymentsService,
    private primeConfig: PrimeNG,
    private primeMessageService: PrimeMessageService,
    private sharedDataService: SharedDataService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private remoteAccountService: RemoteAccountService
  ) {
    this.initDetailedErrors();
    this.translateService.get('primeng').subscribe(res => this.primeConfig.setTranslation(res));
  }


  ngOnInit(): void {
    this.paymentDefaultTranslated = this.translateService.instant(this.constants.paymentTypes.commission);

    this.newPaymentView = new MemoPaymentView();
    this.newPaymentView.maxRelated = this.defaultMaxRelated;
    this.newPaymentView.requestAirlineAudit = true;
    this.newPaymentView.sPaymentTypeTranslated = this.paymentDefaultTranslated;

    // Valores de los combos
    this.paymentService.getACDMFileTypes()
      .pipe(finalize(() => { this.isLoading = false } ), takeWhile(() => this.alive))
      .subscribe({ next: docTypeList => {
        this.docTypesList = docTypeList;
        this.docTypesListSingle = docTypeList.filter(dtl => dtl.fileCode == this.acdm);
      }, error: (error) => {
        this.NameError.description = error.error;
        this.primeMessageService.add({
          key: 'toast-payment-form',
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant(error.error)
        });
      }});

    this.frequencyList = new Array<ComboKeysView>(
                              new ComboKeysView(this.singleFrequency, this.translateService.instant(this.singleFrequency)),
                              new ComboKeysView(this.periodicFrequency, this.translateService.instant(this.periodicFrequency)),
                              new ComboKeysView(this.periodRangeFrequency, this.translateService.instant(this.periodRangeFrequency))
                         );
    this.paymentTypesList = new Array<ComboKeysView>(
                              new ComboKeysView(this.constants.paymentTypes.commission, this.translateService.instant(this.constants.paymentTypes.commission)),
                              new ComboKeysView(this.constants.paymentTypes.fare, this.translateService.instant(this.constants.paymentTypes.fare))
                            );

    // Obtener valores de max.related de cfg.Configurations
    this.sharedDataService.getMaxRelatedData()
      .pipe(finalize(() => { this.isLoading = false }), takeWhile(() => this.alive))
      .subscribe({ next: mr =>{
        this.isErrorConnection = false;
        this.maxRelatedAllowed = this.defaultMaxRelated = mr.defaultValue;
        this.diffValueMaxRelated = mr.diffValueArc;
        this.diffCountry = mr.diffCountry;
      }, error: () => {
        this.isErrorConnection = true;
        this.primeMessageService.add({
          key: 'toast-payment-form',
          sticky: true,
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant('Error On Request'),
        });
      }});
  }

  public getRemotes() {
    this.isLoadingRemotes = true;
    forkJoin([
      this.remoteAccountService.findRemotes(this.newPaymentView.customer.customerId, this.newPaymentView.airline.toString(), this.newPaymentView.bsp, this.constants.remoteUseTypes.sftpUp),
      this.remoteAccountService.findRemotes(this.newPaymentView.customer.customerId, this.newPaymentView.airline.toString(), this.newPaymentView.bsp, this.constants.remoteUseTypes.sftpDown)
    ])
    .pipe(finalize(() => { this.isLoading = false, this.isLoadingRemotes = false } ), takeWhile(() => this.alive))
    .subscribe( ([sftpUp, sftpDown]) => {
      this.setEnableRemotes(true);
      this.uploadRemoteList = sftpUp;
      this.remoteResponseList = sftpDown;

      if (!this.uploadRemoteList.some(r => r.id == this.newPaymentView.remoteUpload?.id)) {
        this.newPaymentView.remoteUpload = null;
      }
      if (!this.remoteResponseList.some(r => r.id == this.newPaymentView.remoteUpload?.id)) {
        this.newPaymentView.remoteResponse = null;
      }
    });
  }

  public savePayment() {
    this.generalError = "";
    this.isLoading = true;
    this.attemptToSave = true;
    this.cancelClicked = false;

    this.setPaymentPeriodRange();
    this.setPaymentMemoPeriodic();
    this.initDetailedErrors();
    this.setPaymentStartTaskDate();
    this.setPaymentDocumentRange();

    if (this.newPaymentView.customer?.databases?.length > 0){
      this.paymentService.addNewPaymentFile(this.newPaymentView)
      .pipe(finalize(() => this.isLoading = false ), takeWhile(() => this.alive))
      .subscribe({ next: paymentSaved => {
        this.paymentSavedOk = true;

        if (paymentSaved.fileName !== this.periodicFileName) {
          this.primeMessageService.add({
            closable: true,
            severity:'success',
            summary: this.translateService.instant('Modal.Success'),
            detail: this.translateService.instant('MemoPayments.Payment Single Saved', { param: paymentSaved.fileName }),
            key: 'toast-payment-form'
          });
        } else if (paymentSaved.fileName === this.periodicFileName) {
          if (!paymentSaved.isEnabled) {
            this.primeMessageService.add({
              closable: true,
              severity:'success',
              summary: this.translateService.instant('Modal.Success'),
              detail: this.translateService.instant('There Will Be No Next Execution'),
              key: 'toast-payment-form'
            });
          } else {
            if (paymentSaved.executeNow) {
              this.primeMessageService.add({
                closable: true,
                severity:'success',
                summary: this.translateService.instant('Modal.Success'),
                detail: this.translateService.instant('The Next Execution Will Be Within Few Seconds'),
                key: 'toast-payment-form'
              });
            } else {
              this.primeMessageService.add({
                closable: true,
                severity:'success',
                summary: this.translateService.instant('Modal.Success'),
                detail: this.translateService.instant('The Next Execution Will Be On', { param: paymentSaved.nextExecution }),
                key: 'toast-payment-form'
              });
            }
          }
        }
        this.attemptToSave = false;
      }, error: (error: HttpErrorResponse) => {
        this.checkTypeError(error);
      }});
    } else {
      this.primeMessageService.add({
        closable: true,
        severity:'error',
        summary: this.translateService.instant('Modal.Error'),
        detail: this.translateService.instant('MemoPayments.No Database Found'),
        key: 'toast-payment-form'
      });
      this.isLoading = false;
    }
  }

  private checkTypeError(error){
    if (this.messageService.get(0)) {
      if (this.messageService.get(0).type === 2 || this.messageService.get(0).type === 3){
        this.messagesError = this.sharedService.getErrorFormMessagesList(this.messageService.get(0).message || error.error || error.message);
        this.messagesError.forEach(currentError =>{
          if (currentError.field){
            this.primeMessageService.add({
              closable: true,
              sticky: true,
              severity:'error',
              summary: this.translateService.instant('Modal.Error'),
              detail: this.translateService.instant(currentError.description),
              key: 'toast-payment-form'
            });
          } else if(this[currentError.field] != undefined) {
            this[currentError.field].description = currentError.description;
            this[currentError.field].quantityMax = currentError.quantityMax;
            this[currentError.field].quantityMin = currentError.quantityMin;
          } else {
            this.primeMessageService.add({
              closable: true,
              sticky: true,
              severity:'error',
              summary: this.translateService.instant('Modal.Error'),
              detail: this.translateService.instant(currentError),
              key: 'toast-payment-form'
            });
          }
        });
      } else {
        this.generalError = this.messageService.get(0).message;
        this.errorRabbit = (this.messageService.get(0).type === MESSAGE_TYPE.serviceUnavailable);

        this.primeMessageService.add({
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant(this.generalError),
          key: 'toast-payment-form'
        });
      }
    }
  }

  public frequencyChoice(){
    this.isLoadingOriginContent = true;
    this.newPaymentView.memoContentOrigin = null;
    this.isSinglePayment = this.newPaymentView.frequency == this.singleFrequency;
    this.isPeriodicPayment = this.newPaymentView.frequency == this.periodicFrequency;
    this.isPeriodRangePayment = this.newPaymentView.frequency == this.periodRangeFrequency;
    this.initPage(true);
    if(this.newPaymentView.frequency == this.periodicFrequency){
      this.newPaymentView.docType = this.docTypesList.find(dtl => dtl.fileCode == this.acm);
    } else {
      this.newPaymentView.docType = this.docTypesList.find(dtl => dtl.fileCode == this.acdm);
    }
    if(!this.originContent){
      this.sharedDataService.getOriginContent(this.singlePaymentMemoContentOrigin)
        .pipe(finalize(() => this.isLoading = false ), takeWhile(() => this.alive))
        .subscribe(originContent => {
            this.allOriginContent = originContent;
            this.setOriginContent(originContent);
          });
    } else {
      this.setOriginContent(this.allOriginContent);
    }
  }

  private setOriginContent(originContent){
    this.originContent = this.isSinglePayment ?
                          originContent.filter(oc => this.singlePaymentMemoContentOrigin.indexOf(oc.messageKey) !== -1) :
                          originContent.filter(oc => this.periodicPaymentMemoContentOrigin.indexOf(oc.messageKey) !== -1);
      this.isLoadingOriginContent = false;
  }

  public memoContentOriginChoice(){
    this.newPaymentView.customer = this.newPaymentView.airline = this.newPaymentView.bsp = this.newPaymentView.memoContent = this.newPaymentView.remoteUpload = null;
    this.setEnableRemotes(false);
    this.fileInput = null;

    if (!this.newPaymentView.memoContentOrigin) {
      this.initPage(true);
      this.initDetailedErrors();
      return;
    }

    this.newPaymentView.fileSequence = null;
    this.NameError = new ErrorView("", "", "");
    // Seleccionar a qué endpoint llamar si no se ha borrado el valor
    this.isLoadingCustomer = true;
    this.memoContentOriginSelected = this.newPaymentView.memoContentOrigin.messageKey;

    // contentOrigin: bsp All active customers with GNR5 product, only airline type (the ones with airlines and countries configured) and the ones that do have other countries configured different than US
    // contentOrigin: arc All active customers with GNR5 product, only airline type (the ones with airlines and countries configured) and the ones that have country US configured
    const contentOrigin = this.bspMemoContentOriginList.some(mco => mco.toLowerCase() == this.newPaymentView.memoContentOrigin.messageKey) ? "bsp" : "arc";

    this.customerService.findAllCustomers({typeCustomer: this.constants.customerTypes.airline, findByCountries: contentOrigin, onlyGNR5: true, onlyActive: true})
      .pipe(finalize(() => {
        this.setARCCountry(contentOrigin);
        this.updateMaxRelated();
        this.isLoading = false;
        this.isLoadingCustomer = false;
      }), takeWhile(() => this.alive))
        .subscribe({ next: customers => {
          this.customerList = customers;
        }, error: (error) => {
          this.NameError.description = error.error;
        }});

  }

  private setARCCountry(contentOrigin: string) {
    if(contentOrigin == "bsp"){
      return;
    }
    this.newPaymentView.bsp = this.diffCountry;
    this.countryList = new Array<CountryView>(new CountryView(this.diffCountry, undefined, undefined, undefined));
  }

  private setPaymentMemoPeriodic() {
    // assign periodic=null if the new payment is either single or period range
    if (this.newPaymentView.memoContent !== null || this.newPaymentView.periodFrom !== null) this.newPaymentView.memoPeriodic = null;
  }

  private setPaymentStartTaskDate() {
    if (this.newPaymentView.startTaskDate != null)
      this.newPaymentView.startTaskDate = new Date(Date.UTC(this.newPaymentView.startTaskDate.getFullYear(), this.newPaymentView.startTaskDate.getMonth(), this.newPaymentView.startTaskDate.getDate()));
    if (this.newPaymentView.endTaskDate != null)
      this.newPaymentView.endTaskDate = new Date(Date.UTC(this.newPaymentView.endTaskDate.getFullYear(), this.newPaymentView.endTaskDate.getMonth(), this.newPaymentView.endTaskDate.getDate()));
  }

  private setPaymentDocumentRange() {
    if (this.newPaymentView.docType.fileCode == "ACM") {
      this.newPaymentView.fromDocumentAdm = null;
      this.newPaymentView.toDocumentAdm = null;
    }
    if (this.newPaymentView.docType.fileCode == "ADM") {
      this.newPaymentView.fromDocument = null;
      this.newPaymentView.toDocument = null;
    }
  }

  private setPaymentPeriodRange() {
    if ((this.newPaymentView.periodFrom == 0 && this.newPaymentView.periodTo == 0)
    || !this.newPaymentView.periodFrom && !this.newPaymentView.periodTo) {
      this.newPaymentView.periodFrom = null;
      this.newPaymentView.periodTo = null;
    }
  }

  public resetPage(){
    this.cancelClicked = false;
    const isTouchedForm = document.getElementById("paymentForm").classList.contains("ng-touched");
    if ((isTouchedForm || this.attemptToSave) && !this.paymentSavedOk) {
      this.confirmationService.confirm ( {
        message: this.translateService.instant('MemoPayments.Text Reset Page Memo'),
        header: this.translateService.instant('Confirmation'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translateService.instant('Yes'),
        rejectLabel: this.translateService.instant('No'),
        accept: () => {
          this.initPage(false);
        }
      });
    } else {
      this.paymentSavedOk = false;
      this.initPage(false);
    }
  }

  public modalChangeFrequency(){
    this.confirmationService.confirm({
      message: this.translateService.instant('MemoPayments.Text Reset Page Memo Frequency'),
      header: this.translateService.instant('Confirmation'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translateService.instant('Yes'),
      rejectLabel: this.translateService.instant('No'),
      accept: () => {
        this.initPage(false);
      }
    });
  }

  // Selections
  public customerSelection() {
    this.newPaymentView.airline = this.newPaymentView.remoteUpload = null;
    this.isLoadingFileSequence = false;
    this.generalError = "";
    if (this.bspMemoContentOriginList.some(mco => mco == this.newPaymentView.memoContentOrigin.messageKey)) {
      this.newPaymentView.bsp = null;
    }

    if (!this.newPaymentView.customer) {
      return;
    }

    // Cada vez que se selecciona o borra un cliente, se resetean aerolínea obligatoriamente y país si no es ARC (US)
    this.isLoadingMacroGroups = true;
    this.airlineList = this.customerList.find(c => c.customerId === this.newPaymentView.customer.customerId).airlinesAndCountries;
    this.deleteAirlineFromList();

    this.macroGroupsService.getAgentsMacroGroupsByCustomer(this.newPaymentView.customer.customerId)
      .pipe(finalize(() => { this.isLoading = false, this.isLoadingMacroGroups = false }), takeWhile(() => this.alive))
      .subscribe(agentsMacroGroups => {
        this.agentsMacroGroupsList = agentsMacroGroups;
      });
  }

  public airlineSelection(){
    // Cada vez que se selecciona o borra una aerolínea, se resetea el país y sus posibles valores
    if (this.newPaymentView.airline){
      this.countryList = this.airlineList.find(a => a.airlineCode == this.newPaymentView.airline).countriesByProductByAirline;
      if (this.bspMemoContentOriginList.some(mco => mco == this.newPaymentView.memoContentOrigin.messageKey)){
        const indexCountry = this.countryList.indexOf(this.countryList.find(c => c.countryCode == this.diffCountry));
        if (indexCountry >= 0) this.countryList.splice(indexCountry, 1);
      }
    }
    if (this.bspMemoContentOriginList.some(mco => mco == this.newPaymentView.memoContentOrigin.messageKey)) {
      this.newPaymentView.bsp = null;
    }
    this.newPaymentView.vat = null;
    this.isLoadingFileSequence = false;
    this.generalError = "";

    if (!this.periodicPaymentMemoContentOrigin.some(mco => mco == this.newPaymentView.memoContentOrigin.messageKey) && this.newPaymentView.airline && this.newPaymentView.bsp) {
      // Se calcula la secuencia para pagos únicos
      this.fileSequenceDefaultValue(this.newPaymentView.customer.customerId, this.newPaymentView.airline, this.newPaymentView.bsp);
    }
  }

  public countrySelection() {
    if(this.newPaymentView.bsp == this.diffCountry) {
      this.newPaymentView.vat = null;
      this.newPaymentView.rmic = null;
    }
    this.updateMaxRelated();

    this.generalError = "";
    if (!this.periodicPaymentMemoContentOrigin.some(mco => mco == this.newPaymentView.memoContentOrigin.messageKey)) {
      this.fileSequenceDefaultValue(this.newPaymentView.customer.customerId, this.newPaymentView.airline, this.newPaymentView.bsp);
    } else {
      this.isLoadingFileSequence = false;
    }
  }

  public updateMaxRelated() {
    this.isMaxRelatedHigherMax = false;
    this.maxRelatedAllowed = this.newPaymentView.bsp === this.diffCountry
      ? this.diffValueMaxRelated
      : this.defaultMaxRelated;

    // Si no se ha tocado el campo "Max Related" actualizar su valor por defecto en función del país elegido
    this.newPaymentView.maxRelated = this.maxRelatedAllowed;
    // Si se ha tocado, mostrar error si el valor escrito es superior al máximo permitido según el país seleccionado
    this.isMaxRelatedHigherMax = (this.newPaymentView.maxRelated > this.maxRelatedAllowed);
  }

  private deleteAirlineFromList() {
    const airlineListClean = [ ...this.airlineList ];
    // Borrar aerolíneas que sean de producto ARM
    this.airlineList.forEach(a => {
      if (a.countriesByProductByAirline[0].product.productAbrev === this.constants.products.ARM)
        this.deleteAirlineByAirlineCode(airlineListClean, a.airlineCode);
    });
    this.airlineList = [ ...airlineListClean];

    if (this.newPaymentView.bsp == undefined) {
      this.airlineList.forEach(a => {
        if (a.countriesByProductByAirline.find(c => c.countryCode == this.diffCountry)) {
          if (a.countriesByProductByAirline.length == 1)
            this.deleteAirlineByAirlineCode(airlineListClean, a.airlineCode);
        }
      });
    } else {
      this.airlineList.forEach(a => {
        if (a.countriesByProductByAirline.find(c => c.countryCode == this.diffCountry) == undefined)
          this.deleteAirlineByAirlineCode(airlineListClean, a.airlineCode);
      });
    }

    this.airlineList = airlineListClean;
  }

  private deleteAirlineByAirlineCode(airlineListClean: Array<AirlineCountriesView>, airlineCode: string) {
    const indexAirline = airlineListClean.indexOf(airlineListClean.find(x => x.airlineCode == airlineCode));
    if (indexAirline >= 0) airlineListClean.splice(indexAirline,1);
  }

  private fileSequenceDefaultValue(customerId: number, airline: string, bsp: string) {
    this.isLoadingFileSequence = true;
    this.paymentService.getFileSequence(customerId, airline, bsp)
      .pipe(finalize(() => this.isLoadingFileSequence = false), takeWhile(() => this.alive))
      .subscribe({ next: (result: FileSequenceDataView) => {
        this.errorFileSequence = false;
        this.newPaymentView.fileSequence = result.startFileSequence;
        this.minFileSequence = result.minFileSequence;
        this.maxFileSequence = result.maxFileSequence;
        this.generalError = "";
      }, error: (error: HttpErrorResponse) => {
        this.errorFileSequence = true;
        this.generalError = this.messageService.get(0).message || error.error || error.message;
        this.primeMessageService.add({
          key: 'toast-payment-form',
          closable: true,
          severity:'error',
          summary: this.translateService.instant('Modal.Error'),
          detail: this.translateService.instant(this.generalError)
        });
      }});
  }

  public maxRelatedSelection() {
    this.newPaymentView.maxRelated = (!isNaN(this.newPaymentView.maxRelated) && this.newPaymentView.maxRelated.toString() !== "") ? Number(this.newPaymentView.maxRelated) : this.newPaymentView.maxRelated;
    // Establecer errores en función del valor escrito y país elegido
    this.isMaxRelatedZero = this.newPaymentView.maxRelated === 0;
    this.isMaxRelatedHigherMax = this.newPaymentView.maxRelated > this.maxRelatedAllowed;
  }

  public paymentTypeSelection(){
    if(this.newPaymentView.paymentType == this.constants.paymentTypes.fare) {
      this.newPaymentView.vat = null;
    }
  }

  public goBack() {
    this.cancelClicked = true;
    const isTouchedForm = document.getElementById("paymentForm").classList.contains("ng-touched");
		if (!this.paymentSavedOk && isTouchedForm) {
      this.confirmationService.confirm({
        message: this.translateService.instant('Text Cancel'),
        header: this.translateService.instant('Confirmation'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translateService.instant('Yes'),
        rejectLabel: this.translateService.instant('No'),
        accept: () => {
          this.sharedService.returnPreviousPage(); //this.showMemoList()
        }
      });
		} else {
			this.sharedService.returnPreviousPage();
		}
  }

  public clearErrors(){
    this.initDetailedErrors();
    this.airlineList = new Array<AirlineCountriesView>();
    this.countryList = new Array<CountryView>();
    this.isMaxRelatedHigherMax = false;
    this.isMaxRelatedZero = false;
    this.errorRabbit = false;
    this.errorFileSequence = false;
    this.generalError = "";
  }

  public initPage(isChangeFrequency) {
    this.paymentService.initFields();
    const frequency = isChangeFrequency ? this.newPaymentView.frequency : null;

    this.newPaymentView = new MemoPaymentView();
    this.newPaymentView.maxRelated = this.defaultMaxRelated;
    this.newPaymentView.requestAirlineAudit = true;
    this.newPaymentView.sPaymentTypeTranslated = this.paymentDefaultTranslated;
    this.newPaymentView.frequency = frequency;

    this.maxRelatedAllowed = this.defaultMaxRelated;

    this.setEnableRemotes(false);
  }

  private initDetailedErrors(){
    this.docTypeError           = new ErrorView("", "", "");
    this.NameError              = new ErrorView("", "", "");
    this.airlineError           = new ErrorView("", "", "");
    this.bspError               = new ErrorView("", "", "");
    this.maxRelatedError        = new ErrorView("", "", "");
    this.fileSequenceError      = new ErrorView("", "", "");
    this.paymentError           = new ErrorView("", "", "");
    this.paymentTypeError       = new ErrorView("", "", "");
    this.vatError               = new ErrorView("", "", "");
    this.fromDocumentError      = new ErrorView("", "", "");
    this.toDocumentError        = new ErrorView("", "", "");
    this.contactNameError       = new ErrorView("", "", "");
    this.contactPhoneError      = new ErrorView("", "", "");
    this.contactEmailError      = new ErrorView("", "", "");
    this.RMICError              = new ErrorView("", "", "");
    this.reasonForMemoError     = new ErrorView("", "", "");
    this.memoContentError       = new ErrorView("", "", "");
    this.endTaskDateError       = new ErrorView("", "", "");
  }

  public checkButtonSaveDisabled(){
    let invalidSpecificForm: boolean;

    if (this.newPaymentView.frequency === this.singleFrequency) {
      invalidSpecificForm = this.singleFormInvalid || !this.newPaymentView.memoContent;
    } else if (this.newPaymentView.frequency === this.periodicFrequency) {
      invalidSpecificForm = (this.periodicFormInvalid) ? this.periodicFormInvalid : !this.newPaymentView.startTaskDate;
    } else {
      invalidSpecificForm = (this.periodRangeFormInvalid) ? this.periodRangeFormInvalid : !this.newPaymentView.periodFrom;
    }

    if (!this.paymentFormInvalid) {
      this.paymentFormInvalid = (this.newPaymentView.toDocument < this.newPaymentView.fromDocument) || (this.newPaymentView.toDocumentAdm < this.newPaymentView.fromDocumentAdm) || this.isMaxRelatedHigherMax || this.isMaxRelatedZero || (this.newPaymentView.periodTo < this.newPaymentView.periodFrom);
    }

    return this.paymentFormInvalid || invalidSpecificForm || this.paymentSavedOk || this.errorRabbit || this.errorFileSequence;
  }

  public attachmentFile(info){
    this.fileInput = info.toRemove ? null : info.file;
  }

  public setEnableRemotes(value: boolean){
    //Method created because in payment-form is required to change this value at emptying remotes
    this.enableRemotes = value;
  }

  ngAfterViewChecked(){
    const inputsPeriodic = document.getElementById("paymentPeriodicForm")?.getElementsByTagName("INPUT");
    const inputsPeriodRange = document.getElementById("paymentPeriodRangeForm")?.getElementsByTagName("INPUT");
    const startDateInvalid = inputsPeriodic ? inputsPeriodic[0].classList.contains("ng-invalid") : false;
    const endDateInvalid = inputsPeriodic ? inputsPeriodic[3].classList.contains("invalid-colors") : false;
    const startPeriodInvalid = inputsPeriodRange ? inputsPeriodRange[0].classList.contains("ng-invalid") || inputsPeriodRange[0].classList.contains("invalid-colors") : false;
    const endPeriodInvalid = inputsPeriodRange ? inputsPeriodRange[1].classList.contains("ng-invalid") || inputsPeriodRange[1].classList.contains("invalid-colors") : false;

    this.periodicFormInvalid = document.getElementById("paymentPeriodicForm")?.classList.contains("ng-invalid");
    if (!this.periodicFormInvalid) this.periodicFormInvalid = startDateInvalid || endDateInvalid;

    this.periodRangeFormInvalid = document.getElementById("paymentPeriodRangeForm")?.classList.contains("ng-invalid");
    if (!this.periodRangeFormInvalid) this.periodRangeFormInvalid = startPeriodInvalid || endPeriodInvalid;

    this.paymentFormInvalid  = document.getElementById("paymentForm")?.classList.contains("ng-invalid");
    this.periodicFormInvalid = document.getElementById("paymentPeriodicForm")?.classList.contains("ng-invalid");
    this.singleFormInvalid   = document.getElementById("paymentSingleForm")?.classList.contains("ng-invalid");
    this.periodRangeFormInvalid   = document.getElementById("paymentPeriodRangeForm")?.classList.contains("ng-invalid");

    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
		// prevent memory leak when component destroyed
    this.alive = false;
    this.changeDetectorRef.detach();
  }
}
